(function () {
    'use strict';

    function initNavigation() {
        var toggle = document.querySelector('[data-nav-toggle]');
        var navigation = document.querySelector('[data-site-nav]');

        if (!toggle || !navigation) {
            return;
        }

        function closeDropdowns() {
            document.querySelectorAll('.site-nav__item.is-open').forEach(function (openItem) {
                openItem.classList.remove('is-open');
                var openToggle = openItem.querySelector('[data-dropdown-toggle]');
                if (openToggle) {
                    openToggle.setAttribute('aria-expanded', 'false');
                }
            });
        }

        toggle.addEventListener('click', function () {
            var isOpen = navigation.classList.toggle('is-open');
            toggle.setAttribute('aria-expanded', String(isOpen));
        });

        document.querySelectorAll('[data-dropdown-toggle]').forEach(function (dropdownToggle) {
            dropdownToggle.addEventListener('click', function () {
                var item = dropdownToggle.closest('.site-nav__item');
                var wasOpen = item.classList.contains('is-open');

                closeDropdowns();

                item.classList.toggle('is-open', !wasOpen);
                dropdownToggle.setAttribute('aria-expanded', String(!wasOpen));
            });
        });

        document.querySelectorAll('[data-dropdown-close]').forEach(function (closeButton) {
            closeButton.addEventListener('click', function () {
                closeDropdowns();
                closeButton.closest('.site-nav__item')?.querySelector('[data-dropdown-toggle]')?.focus();
            });
        });

        navigation.addEventListener('click', function (event) {
            if (event.target.closest('.site-nav__service-link')) {
                closeDropdowns();
            }

            if (event.target.closest('a') && window.matchMedia('(max-width: 991.98px)').matches) {
                navigation.classList.remove('is-open');
                toggle.setAttribute('aria-expanded', 'false');
            }
        });

        document.addEventListener('click', function (event) {
            if (!event.target.closest('.site-nav__item--dropdown')) {
                closeDropdowns();
            }
        });

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
                closeDropdowns();
            }
        });
    }

    function normalize(value) {
        return String(value || '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .replace(/[^a-z0-9\s]/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
    }

    function searchableText(item) {
        return normalize([
            item.title,
            item.eyebrow,
            item.summary,
            (item.keywords || []).join(' '),
            (item.requirements || []).join(' ')
        ].join(' '));
    }

    function scoreResult(item, query) {
        var title = normalize(item.title);
        var keywords = normalize((item.keywords || []).join(' '));
        var requirements = normalize((item.requirements || []).join(' '));
        var content = searchableText(item);

        if (!content.includes(query)) {
            return 0;
        }

        if (title === query) return 120;
        if (title.startsWith(query)) return 90;
        if (title.includes(query)) return 70;
        if (keywords.includes(query)) return 50;
        if (requirements.includes(query)) return 35;
        return 20;
    }

    function resultTypeLabel(type) {
        if (type === 'faq') return 'FAQ';
        if (type === 'service-category') return 'Kategori layanan';
        return 'Layanan & persyaratan';
    }

    function createResultElement(item) {
        var link = document.createElement('a');
        link.className = 'search-result';
        link.href = item.url;

        var type = document.createElement('span');
        type.className = 'search-result__type';
        type.textContent = resultTypeLabel(item.type);

        var title = document.createElement('span');
        title.className = 'search-result__title';
        title.textContent = item.title;

        var summary = document.createElement('span');
        summary.className = 'search-result__summary';
        summary.textContent = item.summary;

        link.append(type, title, summary);

        if (item.requirements && item.requirements.length) {
            var requirements = document.createElement('span');
            requirements.className = 'search-result__requirements';
            requirements.textContent = 'Persyaratan: ' + item.requirements.slice(0, 3).join(' · ');
            link.appendChild(requirements);
        }

        return link;
    }

    function initServiceSearch() {
        var root = document.querySelector('[data-service-search]');
        var source = document.getElementById('landing-search-index');

        if (!root || !source) {
            return;
        }

        var input = root.querySelector('input[type="search"]');
        var results = root.querySelector('.service-search__results');
        var index = [];
        var activeIndex = -1;

        try {
            index = JSON.parse(source.textContent || '[]');
        } catch (error) {
            results.textContent = 'Pencarian belum dapat digunakan.';
            return;
        }

        function closeResults() {
            results.hidden = true;
            results.replaceChildren();
            input.setAttribute('aria-expanded', 'false');
            activeIndex = -1;
        }

        function updateActiveResult(direction) {
            var links = Array.from(results.querySelectorAll('.search-result'));
            if (!links.length) return;

            activeIndex = (activeIndex + direction + links.length) % links.length;
            links.forEach(function (link, indexValue) {
                link.classList.toggle('is-active', indexValue === activeIndex);
            });
            links[activeIndex].focus();
        }

        function runSearch(value) {
            var query = normalize(value);
            results.replaceChildren();
            activeIndex = -1;

            if (query.length < 2) {
                closeResults();
                return;
            }

            var matches = index
                .map(function (item) {
                    return { item: item, score: scoreResult(item, query) };
                })
                .filter(function (result) {
                    return result.score > 0;
                })
                .sort(function (left, right) {
                    return right.score - left.score;
                })
                .slice(0, 8);

            if (!matches.length) {
                var empty = document.createElement('p');
                empty.className = 'service-search__empty';
                empty.textContent = 'Belum ada layanan atau FAQ yang cocok dengan “' + value.trim() + '”.';
                results.appendChild(empty);
            } else {
                matches.forEach(function (match) {
                    results.appendChild(createResultElement(match.item));
                });
            }

            results.hidden = false;
            input.setAttribute('aria-expanded', 'true');
        }

        input.addEventListener('input', function () {
            runSearch(input.value);
        });

        input.addEventListener('keydown', function (event) {
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                updateActiveResult(1);
            } else if (event.key === 'Escape') {
                closeResults();
            }
        });

        root.addEventListener('keydown', function (event) {
            if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
                event.preventDefault();
                updateActiveResult(event.key === 'ArrowDown' ? 1 : -1);
            } else if (event.key === 'Escape') {
                input.focus();
                closeResults();
            }
        });

        document.querySelectorAll('[data-service-query]').forEach(function (trigger) {
            trigger.addEventListener('click', function (event) {
                var query = trigger.getAttribute('data-service-query');
                if (!query || !document.body.classList.contains('landing-v2')) {
                    return;
                }

                event.preventDefault();
                document.getElementById('layanan').scrollIntoView({ behavior: 'smooth' });
                input.value = query;
                runSearch(query);
                window.setTimeout(function () {
                    input.focus();
                }, 350);
            });
        });

        document.addEventListener('click', function (event) {
            if (!root.contains(event.target)) {
                closeResults();
            }
        });
    }

    function initSocialAccordion() {
        var cards = Array.from(document.querySelectorAll('[data-social-card]'));
        if (!cards.length) return;
        var mobileQuery = '(max-width: 767.98px)';
        var mobile = window.matchMedia(mobileQuery);
        var isMobile = function () {
            return window.matchMedia(mobileQuery).matches;
        };
        var wasMobile = isMobile();

        function setCardState(card, isOpen) {
            var toggle = card.querySelector('[data-social-toggle]');
            var panel = card.querySelector('[data-social-panel]');

            if (!toggle || !panel) return;

            card.classList.toggle('is-open', isOpen);
            toggle.setAttribute('aria-expanded', String(isOpen));
            panel.hidden = !isOpen;
        }

        cards.forEach(function (card) {
            var toggle = card.querySelector('[data-social-toggle]');
            if (!toggle) return;

            toggle.addEventListener('click', function () {
                var willOpen = toggle.getAttribute('aria-expanded') !== 'true';
                if (isMobile() && willOpen) {
                    cards.forEach(function (otherCard) {
                        if (otherCard !== card) setCardState(otherCard, false);
                    });
                }
                setCardState(card, willOpen);
            });
        });

        function syncLayout() {
            wasMobile = isMobile();
            cards.forEach(function (card, index) {
                setCardState(card, !wasMobile || index === 0);
            });
        }

        syncLayout();
        mobile.addEventListener('change', syncLayout);
        window.addEventListener('resize', function () {
            if (isMobile() !== wasMobile) syncLayout();
        });
    }

    function setFaqState(disclosure, isOpen) {
        var toggle = disclosure.querySelector('[data-faq-toggle]');
        var panel = disclosure.querySelector('[data-faq-panel]');

        if (!toggle || !panel) return;

        disclosure.classList.toggle('is-open', isOpen);
        toggle.setAttribute('aria-expanded', String(isOpen));
        panel.setAttribute('aria-hidden', String(!isOpen));
        panel.inert = !isOpen;
    }

    function initFaqDirectory() {
        var root = document.querySelector('[data-faq-directory]');

        if (!root) return;

        var input = root.querySelector('[data-faq-search-input]');
        var filters = Array.from(root.querySelectorAll('[data-faq-filter]'));
        var disclosures = Array.from(root.querySelectorAll('[data-faq-disclosure]'));
        var groups = Array.from(root.querySelectorAll('[data-faq-group]'));
        var resultCount = root.querySelector('[data-faq-result-count]');
        var empty = root.querySelector('[data-faq-empty]');
        var activeCategory = 'all';

        function applyFilters() {
            var query = normalize(input ? input.value : '');
            var visibleCount = 0;

            disclosures.forEach(function (disclosure) {
                var matchesCategory = activeCategory === 'all'
                    || disclosure.getAttribute('data-faq-category') === activeCategory;
                var matchesQuery = !query
                    || normalize(disclosure.getAttribute('data-faq-search')).includes(query);
                var isVisible = matchesCategory && matchesQuery;

                disclosure.hidden = !isVisible;

                if (!isVisible) {
                    setFaqState(disclosure, false);
                } else {
                    visibleCount += 1;
                }
            });

            groups.forEach(function (group) {
                group.hidden = !group.querySelector('[data-faq-disclosure]:not([hidden])');
            });

            if (resultCount) {
                resultCount.textContent = visibleCount + ' pertanyaan ditemukan';
            }

            if (empty) {
                empty.hidden = visibleCount !== 0;
            }
        }

        function selectCategory(category) {
            activeCategory = category;
            filters.forEach(function (filter) {
                var isActive = filter.getAttribute('data-faq-filter') === category;
                filter.classList.toggle('is-active', isActive);
                filter.setAttribute('aria-pressed', String(isActive));
            });
            applyFilters();
        }

        filters.forEach(function (filter) {
            filter.addEventListener('click', function () {
                selectCategory(filter.getAttribute('data-faq-filter') || 'all');
            });
        });

        if (input) {
            input.addEventListener('input', applyFilters);
        }

        root.addEventListener('faq:reset', function () {
            if (input) input.value = '';
            selectCategory('all');
        });

        applyFilters();
    }

    function initFaqDisclosures() {
        var disclosures = Array.from(document.querySelectorAll('[data-faq-disclosure]'));

        if (!disclosures.length) return;

        function closeSiblings(disclosure) {
            var scope = disclosure.closest('[data-faq-directory]') || disclosure.closest('[data-faq-list]');

            if (!scope) return;

            scope.querySelectorAll('[data-faq-disclosure].is-open').forEach(function (openDisclosure) {
                if (openDisclosure !== disclosure) {
                    setFaqState(openDisclosure, false);
                }
            });
        }

        function openFromHash() {
            if (!window.location.hash) return;

            var id;

            try {
                id = decodeURIComponent(window.location.hash.slice(1));
            } catch (error) {
                return;
            }

            var target = document.getElementById(id);

            if (!target || !target.matches('[data-faq-disclosure]')) return;

            var directory = target.closest('[data-faq-directory]');
            if (directory) {
                directory.dispatchEvent(new CustomEvent('faq:reset'));
            }

            closeSiblings(target);
            setFaqState(target, true);

            window.requestAnimationFrame(function () {
                target.scrollIntoView({ block: 'center' });
            });
        }

        disclosures.forEach(function (disclosure) {
            var toggle = disclosure.querySelector('[data-faq-toggle]');

            if (!toggle) return;

            toggle.addEventListener('click', function () {
                var willOpen = toggle.getAttribute('aria-expanded') !== 'true';

                if (willOpen) closeSiblings(disclosure);
                setFaqState(disclosure, willOpen);
            });
        });

        openFromHash();
        window.addEventListener('hashchange', openFromHash);
    }

    /**
     * Inisialisasi Accordion Sublayanan & Persyaratan di Halaman Services (/layanan/{category}):
     * - Interaksi Independen: User dapat membuka/menutup beberapa accordion sekaligus.
     * - Aksesibilitas (A11y): Mengelola `aria-expanded`, `aria-hidden`, dan atribut `inert`.
     * - Deep-Link via URL Hash: Fungsi `openDisclosureFromHash()` otomatis membuka kartu
     *   layanan yang dicari jika URL memuat hash (misal: `/layanan/akta-kelahiran#layanan-1`).
     */
    function initServiceDisclosures() {
        var disclosures = Array.from(document.querySelectorAll('[data-service-disclosure]'));

        if (!disclosures.length) {
            return;
        }

        function setDisclosureState(disclosure, isOpen) {
            var toggle = disclosure.querySelector('[data-service-disclosure-toggle]');
            var panel = disclosure.querySelector('[data-service-disclosure-panel]');

            if (!toggle || !panel) {
                return;
            }

            disclosure.classList.toggle('is-open', isOpen);
            toggle.setAttribute('aria-expanded', String(isOpen));
            panel.setAttribute('aria-hidden', String(!isOpen));
            panel.inert = !isOpen;

            if (!isOpen) {
                disclosure.dispatchEvent(new CustomEvent('service:collapsed'));
            }
        }

        function openDisclosureFromHash() {
            if (!window.location.hash) {
                return;
            }

            var id;

            try {
                id = decodeURIComponent(window.location.hash.slice(1));
            } catch (error) {
                return;
            }

            var target = document.getElementById(id);

            if (!target || !target.matches('[data-service-disclosure]')) {
                return;
            }

            setDisclosureState(target, true);
            window.requestAnimationFrame(function () {
                target.scrollIntoView({ block: 'start' });
            });
        }

        disclosures.forEach(function (disclosure) {
            var toggle = disclosure.querySelector('[data-service-disclosure-toggle]');

            if (!toggle) {
                return;
            }

            toggle.addEventListener('click', function () {
                setDisclosureState(disclosure, toggle.getAttribute('aria-expanded') !== 'true');
            });
        });

        openDisclosureFromHash();
        window.addEventListener('hashchange', openDisclosureFromHash);
    }

    /**
     * Disclosure contoh dokumen pada setiap baris persyaratan:
     * - Hanya dirender untuk persyaratan yang mempunyai `examples`.
     * - Maksimal satu contoh terbuka di dalam satu layanan agar halaman mobile tetap ringkas.
     * - State direset saat accordion layanan induknya ditutup.
     */
    function initRequirementExamples() {
        var requirements = Array.from(document.querySelectorAll('[data-requirement-example]'));

        if (!requirements.length) {
            return;
        }

        function loadRequirementImages(requirement) {
            requirement.querySelectorAll('img[data-requirement-example-src]').forEach(function (image) {
                image.src = image.dataset.requirementExampleSrc;
                image.removeAttribute('data-requirement-example-src');
            });
        }

        function setRequirementState(requirement, isOpen) {
            var toggle = requirement.querySelector('[data-requirement-example-toggle]');
            var panel = requirement.querySelector('[data-requirement-example-panel]');

            if (!toggle || !panel) {
                return;
            }

            if (isOpen) {
                loadRequirementImages(requirement);
            }

            requirement.classList.toggle('is-open', isOpen);
            toggle.setAttribute('aria-expanded', String(isOpen));
            panel.setAttribute('aria-hidden', String(!isOpen));
            panel.inert = !isOpen;
        }

        function closeSiblings(requirement) {
            var service = requirement.closest('[data-service-disclosure]');

            if (!service) {
                return;
            }

            service.querySelectorAll('[data-requirement-example].is-open').forEach(function (openRequirement) {
                if (openRequirement !== requirement) {
                    setRequirementState(openRequirement, false);
                }
            });
        }

        requirements.forEach(function (requirement) {
            var toggle = requirement.querySelector('[data-requirement-example-toggle]');
            var service = requirement.closest('[data-service-disclosure]');

            if (!toggle) {
                return;
            }

            toggle.addEventListener('click', function () {
                var willOpen = toggle.getAttribute('aria-expanded') !== 'true';

                if (willOpen) {
                    closeSiblings(requirement);
                }

                setRequirementState(requirement, willOpen);
            });

            if (service) {
                service.addEventListener('service:collapsed', function () {
                    setRequirementState(requirement, false);
                });
            }
        });
    }

    function initAboutGallery() {
        document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
            var toggle = gallery.querySelector('[data-gallery-toggle]');
            var extras = Array.from(gallery.querySelectorAll('[data-gallery-extra]'));

            if (!toggle || !extras.length) {
                return;
            }

            var label = toggle.querySelector('[data-gallery-toggle-label]');
            var icon = toggle.querySelector('[aria-hidden="true"]');

            toggle.addEventListener('click', function () {
                var willExpand = toggle.getAttribute('aria-expanded') !== 'true';

                extras.forEach(function (item) {
                    item.hidden = !willExpand;
                });

                toggle.setAttribute('aria-expanded', String(willExpand));

                if (label) {
                    label.textContent = willExpand ? 'Tampilkan lebih sedikit' : 'Lihat semua foto';
                }

                if (icon) {
                    icon.textContent = willExpand ? '↑' : '↓';
                }
            });
        });
    }

    function initSocialEmbeds() {
        document.querySelectorAll('[data-social-embed-natural-width]').forEach(function (embed) {
            var iframe = embed.querySelector('iframe');
            var naturalWidth = Number(embed.dataset.socialEmbedNaturalWidth);

            if (!iframe || !naturalWidth) {
                return;
            }

            function fitEmbed() {
                if (!embed.clientWidth) {
                    return;
                }

                var scale = Math.min(1, embed.clientWidth / naturalWidth);
                embed.style.setProperty('--social-embed-scale', String(scale));
                iframe.style.height = Math.ceil(embed.clientHeight / scale) + 'px';
            }

            fitEmbed();

            if (window.ResizeObserver) {
                new ResizeObserver(fitEmbed).observe(embed);
            } else {
                window.addEventListener('resize', fitEmbed);
            }
        });
    }

    // Popup informasi (blanko KTP & pengumuman penting): sekali per sesi browser.
    function initInfoPopup() {
        var popup = document.querySelector('[data-info-popup]');
        var storageKey = 'landingInfoPopupSeen';

        if (!popup) {
            return;
        }

        try {
            if (window.sessionStorage.getItem(storageKey)) {
                return;
            }
        } catch (error) {
            // sessionStorage tak tersedia (mis. mode privat ketat): tetap tampilkan.
        }

        var previousFocus = document.activeElement;

        function close() {
            popup.hidden = true;
            document.body.classList.remove('has-info-popup');
            document.removeEventListener('keydown', onKeydown);
            try {
                window.sessionStorage.setItem(storageKey, '1');
            } catch (error) {
                // abaikan
            }
            if (previousFocus && previousFocus.focus) {
                previousFocus.focus();
            }
        }

        function onKeydown(event) {
            if (event.key === 'Escape') {
                close();
            }
        }

        popup.querySelectorAll('[data-info-popup-close]').forEach(function (button) {
            button.addEventListener('click', close);
        });

        popup.hidden = false;
        document.body.classList.add('has-info-popup');
        document.addEventListener('keydown', onKeydown);
        popup.querySelector('.info-popup__close').focus();
    }

    document.addEventListener('DOMContentLoaded', function () {
        initInfoPopup();
        initNavigation();
        initServiceSearch();
        initSocialAccordion();
        initFaqDirectory();
        initFaqDisclosures();
        initServiceDisclosures();
        initRequirementExamples();
        initAboutGallery();
        initSocialEmbeds();
    });
})();
